'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  container: {
    backgroundColor: '#FFF',
    padding: '5px'
  },
  table: {
    borderCollapse: 'separate'
  },
  cellOuter: {
    cursor: 'pointer',
    padding: '1px'
  },
  cell: {
    default: {
      border: '1px solid #CCC'
    },
    active: {
      backgroundColor: 'var(--resizeGridBoxHvrBg)'
    },
    mouseOver: {
      backgroundColor: '#DEF'
    },
    nonSelectable: {
      backgroundColor: '#e6e9ea'
    },
    selected: {
      border: '1px solid #000',
      backgroundColor: '#000'
    }
  },
  dimensions: {
    background: '#F0F0F0',
    color: '#444',
    fontWeight: 'bold',
    textAlign: 'center',
    position: 'absolute',
    wordBreak: 'keep-all',
    padding: '5px',
    zIndex: 1000
  }
};
